(() => {
  // The editor can reload the product section without a full page navigation.
  if (window.GalGonenBackInStock) {
    window.GalGonenBackInStock.refresh();
    return;
  }

  const popupId = 'gw-stock-fulfilled-iframe';
  const stylesheetId = 'gal-gonen-back-in-stock-design';
  const settingsStyleId = `${stylesheetId}-settings`;
  let settings = {};
  let popup = null;
  let observedDocument = null;
  let contentObserver = null;
  const originalValues = new Map();

  function restoreContent() {
    originalValues.forEach((values, element) => {
      values.forEach((value, property) => {
        element[property] = value;
      });
    });
    originalValues.clear();
  }

  function updateText(element, property, value) {
    if (!element) return;
    const original = originalValues.get(element);
    if (typeof value !== 'string' || !value.trim()) {
      if (original?.has(property)) {
        element[property] = original.get(property);
        original.delete(property);
        if (!original.size) originalValues.delete(element);
      }
      return;
    }

    if (element[property] === value) return;
    if (!original) originalValues.set(element, new Map());
    const values = originalValues.get(element);
    if (!values.has(property)) values.set(property, element[property]);
    element[property] = value;
  }

  function applyText(popupDocument) {
    const text = settings.text || {};
    // Only visible labels/placeholders change; Vue models and click handlers stay in place.
    [
      ['.modal-title', text.title],
      ['.notification-message', text.description],
      ['#email-tab', text.emailLabel],
      ['#sms-tab', text.smsLabel],
      ['.notify-button', text.submitLabel],
      ['.privacy-text', text.privacy]
    ].forEach(([selector, value]) => updateText(popupDocument.querySelector(selector), 'textContent', value));
    updateText(popupDocument.querySelector('.email-input'), 'placeholder', text.emailPlaceholder);
    updateText(popupDocument.querySelector('.vue-tel-input input'), 'placeholder', text.smsPlaceholder);
  }

  function disconnectContent() {
    contentObserver?.disconnect();
    contentObserver = null;
    observedDocument = null;
    restoreContent();
  }

  function applyDesign() {
    if (!popup) return;
    try {
      // CartBite currently renders a same-origin srcdoc iframe.
      const popupDocument = popup.contentDocument;
      if (!popupDocument?.head) return;
      if (!settings.enabled || !settings.customizePopup) {
        disconnectContent();
        popupDocument.getElementById(stylesheetId)?.remove();
        popupDocument.getElementById(settingsStyleId)?.remove();
        return;
      }

      let stylesheet = popupDocument.getElementById(stylesheetId);
      if (!stylesheet) {
        stylesheet = popupDocument.createElement('link');
        stylesheet.id = stylesheetId;
        stylesheet.rel = 'stylesheet';
        stylesheet.href = settings.stylesheetUrl;
        popupDocument.head.appendChild(stylesheet);
      }
      let style = popupDocument.getElementById(settingsStyleId);
      if (!style) {
        style = popupDocument.createElement('style');
        style.id = settingsStyleId;
        popupDocument.head.appendChild(style);
      }
      if (style.textContent !== settings.popupCss) style.textContent = settings.popupCss;

      if (observedDocument !== popupDocument && popupDocument.body) {
        disconnectContent();
        observedDocument = popupDocument;
        // Vue recreates the input on channel changes, and may update text after mounting.
        contentObserver = new MutationObserver(() => applyText(popupDocument));
        contentObserver.observe(popupDocument.body, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['placeholder']
        });
      }
      applyText(popupDocument);
    } catch (error) {
      // A future cross-origin popup would require configuration through CartBite.
      if (error.name !== 'SecurityError') throw error;
    }
  }

  function bindPopup() {
    const frame = document.getElementById(popupId);
    if (frame === popup) return;
    disconnectContent();
    popup = frame;
    if (!frame) return;
    frame.addEventListener('load', () => {
      if (popup === frame) applyDesign();
    });
    applyDesign();
  }

  function refreshSettings() {
    const config = document.querySelector('[data-back-in-stock-settings]');
    try {
      settings = config ? JSON.parse(config.textContent) : {};
    } catch {
      settings = {};
    }
    bindPopup();
    applyDesign();
  }

  window.GalGonenBackInStock = { refresh: refreshSettings };
  refreshSettings();
  new MutationObserver(bindPopup).observe(document.body, { childList: true });
  document.addEventListener('shopify:section:load', refreshSettings);
  document.addEventListener('shopify:section:unload', refreshSettings);
})();
